export default __webpack_public_path__ + "static/open_graph_illus_1200x630-873260c9d2d88f4ba907c3567beeb1e7.png";